import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BasePageComponent } from '../../../../base-page';
import { Account } from '../../../../../model/account.model';
import { FormValidator } from '../../../../../model/champs_formulaire/form-validator.model';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseService } from '../../../base/base.service';
import { FormService } from '../../../../../shared/services/form.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ValidatorAffectedService } from '../validator-affected.service';
import { AccountService } from '../../../../../services/ServiceEntity/account.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../interfaces/app-state';
import { HttpService } from '../../../../../services/http/http.service';
import { TranslateService } from '@ngx-translate/core';
import { ConstantValidatorsAffected } from '../validator-affected.url';
import { ConstantHome } from '../../../home/home.url';
import { Url } from '../../../../../shared/constant/url.constant';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { CountryUpdateComponent } from '../../../countries/update/country-update.component';
import { fadeIn } from '../../../../../animations/form-error';
import { IOption } from '../../../../../ui/interfaces/option';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ChampsFormulaireColumnName, IChampsFormulaireColumnName } from '../../champs_formulaires/champs-formulaire-column-name';
import { ChampsFormulaire, TypeForm } from '../../../../../model/champs_formulaire/champs-formulaire.model';
import { IServiceItem } from '../../../../../model/service-item.model';
import { ServiceItemService } from '../../../service-items/service-item.service';
import { MoniesService } from '../../../monies/monies.service';
import { TCModalService } from '../../../../../ui/services/modal/modal.service';
import { ChampsFormulaireService } from '../../champs_formulaires/champs-formulaire.service';
import { TIME_MIN_REQUEST } from '../../../../../shared/constant/request.contant';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../../shared/constant/css-style/css-class.constant';
import { IValidatorAffectedColumnName, ValidatorAffectedColumnName } from '../validator-affected-column-name';
import { Validators as ValidatorsModel } from '../../../../../model/champs_formulaire/validators.model';
import { ValidatorService } from '../../validators/validator.service';
import { ConstantChampsFormulaires } from '../../champs_formulaires/champs-formulaire.url';

/**
 * Permet de gérer l'ajout des countries.
 */
@Component({
  selector: 'app-validator-affected-update',
  templateUrl: './validator-affected-update.component.html',
  animations: [fadeIn]
})
export class ValidatorAffectedUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  formSelected: ChampsFormulaire;
  theDialogRef: MatDialogRef<ValidatorAffectedUpdateComponent>;
  private subs$ = new Subject<void>();
  typeForms: IOption[] = [];
  editForm: UntypedFormGroup;
  column: IValidatorAffectedColumnName;

  validatorsList: ValidatorsModel[] = [];
  filteredOptions: Observable<ValidatorsModel[]>;

  constructor(
    private router: Router,
    private validatorService: ValidatorService,
    private serviceItemService: ServiceItemService,
    private validatorAffectedService: ValidatorAffectedService,
    public baseService: BaseService,
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<ValidatorAffectedUpdateComponent>,
    private columnName: ValidatorAffectedColumnName,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct validator affected liste');
    const column = this.columnName.getColumnName();
    this.theDialogRef = this.dialogRef;
    this.column = column;
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init validator affected liste');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        this.validatorAffectedService.getObjetSelectObs()
          .pipe(takeUntil(this.subs$)).subscribe((res: FormValidator) => {
          console.log('## get formulaire selected to liste');
          this.getValidatorsList(); // after 500ms.
          try {
            console.log('## data: ', res);
            // this.formSelected = res.formulaire;
            this.formSelected = res.champsFormulaire;
            const f = this.formSelected;
            this.editForm.patchValue({
              [this.column.id]: res.id,
              [this.column.champsFormulaire]: f.label + ' - ' + f?.formulaire?.titre,
              [this.column.validator]: res.validator,
              [this.column.errorMessage]: res.errorMessage,
              [this.column.validatorValue]: res.validatorValue
            });
          } catch (e) {
            console.log('## error get country selected: ' + e.message);
          }
        });
        super.setLoaded();
      });
  }

  ngOnDestroy() {
    console.log('## destroy country add');
    this.formService.free(this.subs$);
    this.successSave = false;
  }

  getValidatorsList() {
    setTimeout(() => {
      this.validatorService.query(this.validatorService.list_url)
        .pipe(map((response: HttpResponse<ValidatorsModel[]>) => response.body))
        .subscribe((res) => {
          const rs = res ? res : [];
          console.log('## data v: ', rs);
          this.validatorsList = rs;
          this.filteredOptions = this.editForm.get(this.column.validator).valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value))
            );
        });
    }, TIME_MIN_REQUEST);
  }

  private _filter(value: string): ValidatorsModel[] {
    let filteredList;
    try {
      const filterValue = value.toLowerCase();
      filteredList = this.validatorsList.filter(option => option.type.toLowerCase()
        .includes(filterValue));
    } catch (e) {
      console.log('## error filter service item: ' + e.message);
    }
    return filteredList;
  }

  displayFnF(subject: ChampsFormulaire) {
    return subject ? subject.label : '';
  }

  displayFnServiceItem(subject: ValidatorsModel) {
    return subject ? subject.type : '';
  }

  initForm(fb: UntypedFormBuilder, column: IValidatorAffectedColumnName) {
    if (fb && column) {
      this.editForm = fb.group({
        [column.id]: [''],
        [column.errorMessage]: ['', [Validators.required]],
        [column.validatorValue]: [''],
        [column.validator]: ['', [Validators.required]],
        [column.champsFormulaire]: ['', [Validators.required]]
      });
    }
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## save validator');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c = this.createFromForm();
    console.log('## c: ', c);
    this.validatorAffectedService.update(c,
      this.validatorAffectedService.resourceUrl)
      .subscribe(res => {
          console.log('## success create validator');
          this.serverHasError = false;
          this.responseFromServer();
          this.editForm.reset();
          this.successSave = true;
          this.validatorAffectedService.getAllObjet();
        },
        err => {
          console.log('## error create validator: ', err);
          this.responseFromServer();
          this.serverHasError = true;
          this.successSave = false;
        });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): FormValidator {
    return {
      ...new FormValidator(),
      id: this.editForm.get([this.column.id]).value,
      errorMessage: this.editForm.get([this.column.errorMessage]).value,
      validatorValue: this.editForm.get([this.column.validatorValue]).value,
      validatorId: this.editForm.get([this.column.validator]).value.id,
      champsFormulaireId: this.formSelected.id
    };
  }

  closeModal() {
    console.log('## close formulaire add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

  reset() {
    this.editForm.reset();
  }


}
